import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate, useParams} from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Button} from "@mui/material";
import CustomerRequestsCuttingService from "../../../API/orders/optimization/customer/CustomerRequestsCuttingService";
import CustomerDetailsTable from "../../../components/UI/table/customer-detales/CustomerDetailsTable";
import {constantsErrorMessages} from "../../../Constants";
import CustomerRequestsCuttingEstimateItem from "./CustomerRequestsCuttingEstimateItem";
import CustomerEstimateTableItem from "./CustomerEstimateTableItem";
import CustomerRequestsEdges from "../edges/CustomerRequestsEdges";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import CustomerOrderService from "../../../API/orders/orders/customer/CustomerOrderService";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import {
    buildMyOrdersSectionPath,
    CUSTOMER_ORDERS_SUBMENU_BREADCRUMB,
} from "../../../utils/customerBreadcrumbLabels";
import CheckIcon from '@mui/icons-material/Check';
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import CustomerAccessories from "./CustomerAccessories";
import DetailControllerService from "../../../API/details/customer/DetailControllerService";
import CircularProgress from "@mui/material/CircularProgress";
import FilesItem from "./FilesItem";

const textOrder = [
    "Различные файлы касающиеся заказа",
    "Создание или импорт заявки на раскрой",
    "Список всех деталей на обработку",
    "Добавление кромочного материала и способа его оклеивания",
    "Список материалов не требующих раскроя, а также не требующего оклеивания",
    "Общая смета всех используемых материалов"]

const CustomerOrderItem = () => {
        const profileStorage = JSON.parse(localStorage.getItem("profile"))
        const isOrgOne = !!profileStorage?.userRoles?.find(el => el.name === "ROLE_ONE_ORGANIZATION_USER")
        const pathname = useLocation().pathname
        const params = useParams();
        const navigate = useNavigate();

        const [tab, setTab] = useState(1);
        const [change, setChange] = useState(null);
        const [orderData, setOrderData] = useState({})
        const [tableOptions, setTableOptions] = useState({pageIndex: 0, pageSize: 100, totalElements: 0, searchData: ""})

        const tableOptionsHandle = (nextState) => {
            if (nextState.pageSize !== tableOptions.pageSize) {
                setTableOptions(nextState)
                EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
            }
        }
        const getStartPageSize = () => {
            const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
            const pageSize = pagesData[pathname]?.pageSize
            pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
        }
        const handleChange = (event, newTab) => {
            setTab(newTab);
            EditLocalStoragePagesData(pathname, "tab", newTab)
        };

        const [data, setData] = useState([]);
        const [unable, setUnable] = useState({unableTurn: {}, unablePackage: {}});
        const [isLoading, setIsLoading] = useState(true);
        const [isError, setIsError] = useState(false);
        const [alertData, setAlertData] = useState({}); //type 'error'| 'info' | 'success'| 'warning'

        const initDataOffers = {
            "all": 0,
            "calculated": 0,
            "estimateState": "WAIT_OFFERS"
        }
        const [offersData, setOffersData] = useState(initDataOffers);
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

        useEffect(() => {
            getStartPageSize()
            const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
            const savedTab = pagesData[pathname]?.tab
            const openFirstTab = (orderData.orderType === "CUT" && (savedTab === 3 || savedTab === 5)) || (orderData.orderType === "CUT_PROCESSING" && savedTab === 5)

            if (openFirstTab || !savedTab) {
                setTab(1)
            } else {
                setTab(savedTab)
            }
            CustomerOrderService.getById(params.id)
                .then(function (response) {
                    setOrderData(response.data)
                })
                .catch(function (error) {
                    handleModalAlert(error)
                })
        }, [])

        useEffect(() => {
            setIsLoading(true)
            DetailControllerService.getAllByOrderId(params.id)
                .then(function (response) {
                    const data = response?.data
                    setData(data);
                    setUnable(({unableTurn, unablePackage}) => {
                        data.forEach(row => {
                            unableTurn[row.id] = row.turn;
                            unablePackage[row.id] = row.package;
                        })
                        return {unableTurn, unablePackage}
                    })
                    setIsError(false)
                })
                .catch(function (error) {
                    handleModalAlert(error)
                })
                .finally(() => setIsLoading(false))
        }, [change]);

        const renderContent = () => {
            switch (tab) {
                case 1:
                    return <FilesItem
                        nameOrder={params.customerOrderNumber}
                        year={params.year}
                        orderId={params.id}
                        change={change}
                        setChange={setChange}
                        handleModalAlert={handleModalAlert}
                        customer={true}
                    />

                case 2:
                    return <CustomerRequestsCuttingEstimateItem
                        getAll={CustomerRequestsCuttingService.getAllByCustomerOrderId}
                        isOptimization={false}
                        isRedirectRequestsCutting={false}
                        orderId={params.id}
                        nameOrder={params.customerOrderNumber}
                        // idHeader={orderIdHeader}
                        year={params.year}
                        isOrder={true}
                        isButtonAddRequestsCutting={true}
                        isEstimate={true}
                        isCreateOptimizationCalculation={false}
                        isSetForOptimization={false}
                        customerOrderNumber={orderData.numberCustomer}
                        handleModalAlert={handleModalAlert}
                        isOrgOne={isOrgOne}
                        offersData={offersData}
                    />
                case 3:
                    return isLoading ?
                        <Box sx={{
                            height: `calc(100vh - 410px)`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <CircularProgress disableShrink/>
                        </Box> : <CustomerDetailsTable
                            data={data}
                            unableTurn={unable.unableTurn}
                            unablePackage={unable.unablePackage}
                            pageSize={100}
                            year={params.year}
                            isError={isError}
                            setData={setData}
                            enableEditing={true}
                            orderId={params.id}
                            customerOrderNumber={orderData.numberCustomer}
                            handleModalAlert={handleModalAlert}
                            tableOptionsHandle={tableOptionsHandle}
                            tableOptions={tableOptions}
                        />
                case 4:
                    return <CustomerRequestsEdges orderId={params.id} handleModalAlert={handleModalAlert}/>
                case 5:
                    return <CustomerAccessories orderId={params.id} handleModalAlert={handleModalAlert}></CustomerAccessories>
                default:
                    return <CustomerEstimateTableItem
                        orderId={params.id}
                        customerOrderNumber={orderData.numberCustomer}
                        handleModalAlert={handleModalAlert}
                        year={params.year}
                        isOrgOne={isOrgOne}
                        initDataOffers={initDataOffers}
                        offersData={offersData}
                        setOffersData={setOffersData}
                    />
            }
        }

        return (
            <Box sx={{padding: "0 30px"}}>
                <BreadcrumbsComponent
                    page={orderData.numberCustomer}
                    path={buildMyOrdersSectionPath(CUSTOMER_ORDERS_SUBMENU_BREADCRUMB)}
                />
                <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
                    <Box sx={{display: "flex", flexDirection: "column", gap: "16px"}}>
                        <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                            Заказ № {orderData.numberCustomer}
                        </Typography>
                        <Typography>{textOrder[tab - 1]}</Typography>
                    </Box>
                    <ButtonGroupTabBar activeTab={tab}>
                        <Button tabIndex={2} onClick={(e) => handleChange(e, 2)}>
                            <CheckIcon/>
                            Заявки на раскрой
                        </Button>
                        <Button tabIndex={4} onClick={(e) => handleChange(e, 4)}>
                            <CheckIcon/>
                            Кромки
                        </Button>
                        {orderData.orderType !== "CUT" &&
                            <Button tabIndex={3} onClick={(e) => handleChange(e, 3)}>
                                <CheckIcon/>
                                Обработка
                            </Button>
                        }
                        {orderData.orderType === "CUT_PROCESSING_ACCESSORIES" &&
                            <Button tabIndex={5} onClick={(e) => handleChange(e, 5)}>
                                <CheckIcon/>
                                Фурнитура
                            </Button>
                        }
                        <Button tabIndex={6} onClick={(e) => handleChange(e, 6)}>
                            <CheckIcon/>
                            Общая смета
                        </Button> <Button tabIndex={1} onClick={(e) => handleChange(e, 1)}>
                        <CheckIcon/>
                        Дополнительная информация
                    </Button>
                    </ButtonGroupTabBar>
                    {renderContent()}
                    <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                        return {...alert, open: false}
                    })}/>
                </Box>
            </Box>
        );
    }
;

export default CustomerOrderItem;
